import { Dialog, FileCard } from 'design-system/components';
import { useBoolean } from 'hooks/useBoolean';
import React from 'react';
import { strings } from 'strings';

import { Content, ContentProps as BaseContentProps } from './Content';
import { isSupportedFilter, statusColors, statusIcons, taskDate, taskTitle } from './internal';

export type ContentProps = Omit<BaseContentProps, 'onClose'>;

export interface TaskItemProps extends ContentProps {
  showDate?: boolean;
}

export const TaskItem: React.FC<TaskItemProps> = ({
  task,
  onNoteAdd,
  onSelect,
  showDate = false,
}) => {
  const open = useBoolean(false);

  const status = task.status;
  const title = taskTitle(task, false);
  const date = showDate ? taskDate(task) : undefined;

  const supportedStatus = isSupportedFilter(status);
  const statusColor = supportedStatus ? statusColors[status] : undefined;
  const statusIcon = supportedStatus ? statusIcons[status] : undefined;

  return (
    <>
      <FileCard
        name={title || strings.DisplayNotFound}
        date={date}
        icon={statusIcon}
        iconColor={statusColor}
        onPress={open.setTrue}
      />
      <Dialog
        borderColor={statusColor}
        title={title || strings.DisplayNotFound}
        isOpen={open.value}
        onRequestClose={open.setFalse}
      >
        <Content task={task} onNoteAdd={onNoteAdd} onSelect={onSelect} onClose={open.setFalse} />
      </Dialog>
    </>
  );
};
